import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Links from '@/shared/constants/navegacao';
import { GetDiretoriaDoUsuario } from '@/modules/structure/diretoria/diretoria.service';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import RelatoriosUserLabel from '@/modules/reports/presentation/components/RelatoriosUserLabel';
import { LuScrollText, LuScale, LuGavel } from 'react-icons/lu';

type CardLinkProps = {
  title: string;
  description: string;
  to: string;
  icon: React.ReactNode;
};

function CardLink({ title, description, to, icon }: CardLinkProps) {
  return (
    <Link to={to} className="text-decoration-none text-reset h-100 d-block">
      <Card className="h-100 shadow-sm border-0" style={{ transition: 'box-shadow 0.15s' }}>
        <Card.Body className="d-flex gap-3 align-items-start p-4">
          <span className="text-primary flex-shrink-0" aria-hidden>
            {icon}
          </span>
          <div>
            <Card.Title as="h3" className="h5 mb-2">
              {title}
            </Card.Title>
            <Card.Text className="text-muted mb-0 small">{description}</Card.Text>
          </div>
        </Card.Body>
      </Card>
    </Link>
  );
}

export default function RelatoriosMenuPage() {
  const [hasDiretoria, setHasDiretoria] = useState(false);
  const { permissions } = useNavigationView();

  const canDiretoria = hasDiretoria || permissions.relatoriosDiretoria;
  const canCorregedoria = permissions.relatoriosCorregedoria;

  useEffect(() => {
    GetDiretoriaDoUsuario()
      .then((diretoria) => setHasDiretoria(!!diretoria))
      .catch(() => setHasDiretoria(false));
  }, []);

  return (
    <Container fluid>
      <div className="mb-4 d-flex align-items-end justify-content-between gap-2 flex-wrap">
        <div>
          <h2 className="mb-1">Relatórios de Atividades</h2>
          <p id="escolha-relatorios" className="text-muted mb-0">
            Selecione a área do módulo que deseja acessar.
          </p>
        </div>
        <RelatoriosUserLabel className="mb-1" />
      </div>

      <Row className="g-3">
        {permissions.relatoriosAtividades && (
          <Col md={6} lg={4}>
            <CardLink
              title="Meus Relatórios"
              description="Criar, editar e enviar seus relatórios mensais."
              to={Links.Relatorios_Meus}
              icon={<LuScrollText size={36} strokeWidth={1.35} />}
            />
          </Col>
        )}
        {canDiretoria && (
          <Col md={6} lg={4}>
            <CardLink
              title="Diretoria Regional"
              description="Aprovação/reprovação dos relatórios na diretoria."
              to={Links.Relatorios_Aprovacao}
              icon={<LuScale size={36} strokeWidth={1.35} />}
            />
          </Col>
        )}
        {canCorregedoria && (
          <Col md={6} lg={4}>
            <CardLink
              title="Corregedoria"
              description="Aval final e tramitação na Corregedoria."
              to={Links.Relatorios_Corregedoria}
              icon={<LuGavel size={36} strokeWidth={1.35} />}
            />
          </Col>
        )}
      </Row>
    </Container>
  );
}
